import * as React from 'react'
import { connect } from 'react-redux'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CountUp from 'react-countup';
import CardChip from './CardChip'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import handleViewport from 'react-in-viewport';
import { createChipLabel, getBusinessLineItem, downloadResource } from '../lib/helpers'

const styles = (theme: any) => {
  return {
    chip: {
      color: '#fff',
      margin: '10px',
      fontWeight: 400
    },
    cardContent: {
      paddingBottom: 24,
      fontWeight: 300,
      color: 'grey',
      fontSize: '15px'
    },
    cardContentWithBg: {
      position: 'absolute' as 'absolute',
      bottom: '0',
      background: 'rgba(0,0,0,0.4)',
      width: '100%',
      color: '#fff',
      paddingTop: '0px',
      fontSize: '18px'
    },
    cardAction: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    button: {
      color: '#0093B2'
    },
    bgButton: {
      position: 'absolute' as 'absolute',
      bottom: 0,
      right: 0,
      color: '#fff'
    }
  }
}

interface IProps {
  item: any
  businessLines: any[]
  classes: any
  classSelections: number[]
  onSelect?: (id: number, businessLineId: number) => void
  onRemove?: (id: number, businessLineId: number) => void
  factoidSelections: number[]
  hideAdd?: boolean
  landingArticle?: boolean
  landingPage?: boolean
  inViewport?: boolean
}


class Simple extends React.Component<IProps, {}> {


  public render() {
    const { item, classes, businessLines, landingPage } = this.props
    const buttonPosition: any = { position: 'absolute', bottom: 0, right: 0, marginRight: 0 };
    // MUI styles
    const classStyles = classes
    const { acf } = item
    // Content for the factoid
    let { content } = acf.factoid_content[0]
    if (content) {
      content = content
    }
    const height = acf.factoid_height === 'Single' ? '320px' : '640px'
    // const height = '320px'
    // Its associated business line
    const businessLine = getBusinessLineItem(item, businessLines)
    const containsImage = content.toString().includes('img')
    const extendedContent = landingPage  ? acf.external_link : false

    // @ts-ignore
    const currentlySelected = this.props.factoidSelections.includes(item.id)
      ? true
      : false

  
    const buttonLabel = this.props.hideAdd
      ? ''
      : currentlySelected
        ? 'Remove'
        : 'Add'

    const handleButtonClick = () => {
      if (currentlySelected) {
        if (this.props.onRemove) {
          this.props.onRemove(item.id, businessLine.id)
        }
      } else {
        if (this.props.onSelect) {
          this.props.onSelect(item.id, businessLine.id)
        }
      }
    }


    


    // Cards that contain image in the content
    const withImage = (): React.ReactNode => {
      return (
      <CardWithImage style={{position: 'relative'}}>
          <Card style={{ height }}>
            <CardChip factoid={this.props.item} />
            <CardContent
              dangerouslySetInnerHTML={{
                __html: content
              }}
              className={classStyles.cardContent}

            />
            <CardActions className={classStyles.cardAction} style={{
                  position: 'absolute',
                  bottom: '0px',
                  right: '0px'
            }}>
              {!this.props.hideAdd &&
                !extendedContent && (
                  <Button
                    size="small"
                    className={classStyles.button}
                  onClick={handleButtonClick}
                  style={buttonPosition}
                  >
                    {buttonLabel}
                  </Button>
                )}
              {extendedContent ? (
                <Button size="small" className={classStyles.button} style={buttonPosition} onClick={() => downloadResource(extendedContent)}>
                  <a
                    href={extendedContent}
                    download={true}
                    target="_blank"
                  >
                    Learn more
                  </a>
                </Button>
              ) : null}
            </CardActions>
          </Card>
        </CardWithImage>
      )
    }


    /**
     * Generates features - things like dynamic counters that need
     * react components to work.
     * @param features Array
     */

    const generateFeatures = (features:any) => {

      // if no features, don't try to map them.
      if(!features || !features.length) {
        return null;
      }

      // in the future, we might have multiple features
      const featureComponents = features.map((feature:any, i:number) => {
        switch(feature.acf_fc_layout){
          case "static_counter" : return <h1 key={i}><CountUp duration={2} useEasing={false} suffix={feature.suffix} prefix={feature.prefix} end={parseInt(feature.number, 10)} /></h1>
          default: return null;
        }
      });
      
      return featureComponents;
    }

    // Cards for factoid posts which do have a background image
    const withoutBackground = (inViewportBool:any): React.ReactNode =>  {
      const features = acf.features !== undefined 
      ? generateFeatures(acf.features) 
      : null;
      return (
        <Card style={{ minHeight: height, position: 'relative'}}>
        <CardChip factoid={this.props.item} />
        {
          features !== undefined ? (
            <CardContent
            className={classStyles.cardContent}
          >
                  {
              inViewportBool ? features : null
            }    
          </CardContent>
          ) :  null
        }
        <CardContent
          dangerouslySetInnerHTML={{
            __html: content
          }}
          className={classStyles.cardContent}
        />
        <CardActions className={classStyles.cardAction}>
          {!this.props.hideAdd &&
            !extendedContent&& (
              <Button
                size="small"
                className={classStyles.button}
                onClick={handleButtonClick}
                style={buttonPosition}
              >
                {buttonLabel}
              </Button>
            )}
          {extendedContent ? (
            <Button size="small" className={classStyles.button} onClick={() => downloadResource(extendedContent)}>
              <a href={extendedContent} download={true} target="_blank">
                Learn more
              </a>
            </Button>
          ) : null}
        </CardActions>
      </Card>
      )
    }

    
    // Cards for factoid posts which contain a background image
    const withBackground = (): React.ReactNode => {
      const { url } = acf.factoid_background_image
      return (
        <Card
          style={{
            backgroundImage: `url(${url})`,
            backgroundSize: 'cover',
            minHeight: height ,
            position: 'relative'
          }}
        >
          <CardChip factoid={this.props.item} />
          <CardContent
            dangerouslySetInnerHTML={{
              __html:  content
            }}
            className={`${classStyles.cardContent} ${
              classStyles.cardContentWithBg
            }`}
          />

          {!this.props.hideAdd &&
            !extendedContent&& (
              <Button
                size="small"
                className={classStyles.bgButton}
                onClick={handleButtonClick}
              >
                {buttonLabel}
              </Button>
            )}
          {extendedContent ? (
            <Button size="small" className={classStyles.bgButton} onClick={() => downloadResource(extendedContent)}> 
              <a
                href={extendedContent}
                download={true}
                style={{ color: '#fff' }}
                target="_blank"
              >
                Learn more
              </a>
            </Button>
          ) : null}

        </Card>
      )
    }

    /**
     * Card solely used for Articles section underneath each Service Line block on landing page.
     */
    const Article = (): React.ReactNode => {
      const { url } = acf.factoid_background_image
      return (
        <Card
          style={{
            backgroundImage: `url(${url})`,
            backgroundSize: 'cover',
            height: '300px',
            position: 'relative'
          }}
        >
          <ArticleParentLabel>
            {createChipLabel(this.props.item, businessLines)}
          </ArticleParentLabel>
          <CardContent
            dangerouslySetInnerHTML={{ __html: content }}
            className={`${classStyles.cardContent} ${
              classStyles.cardContentWithBg
            } article-content`}
          />
          {extendedContent ? (
            <Button size="small" className={classStyles.bgButton} onClick={() => downloadResource(extendedContent)} >
              <a
                href={extendedContent}
                download={true}
                style={{ color: '#fff', fontWeight: 300 }}
                target="_blank"
              >
                Learn more
              </a>
            </Button>
          ) : null}
        </Card>
      )
    }
    const {inViewport} = this.props;
 
    return (
      <Outer
      >
        {this.props.landingArticle
          ? Article()
          : acf.factoid_background_image !== false
            ? withBackground()
            : containsImage
              ? withImage()
              : withoutBackground(inViewport)}
      </Outer>
    )
  }
}

export default handleViewport(withStyles(styles)(
  connect(
    (state: any) => ({
      classSelections: state.views.new.selections.classes,
      factoidSelections: state.views.new.selections.factoids,
      businessLines: state.data.businessLines
    }),
    null
  )(Simple))
)

const Outer = styled.div`

transition: 'all 0.5s';

p {
  font-size: 14px;
}
  .article-content {
    height: 50%;
    p {
      transform: translateY(20px);
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: 500;
    }
  }

  h1 {
    font-size: 45px;
  }

  h2 {
    font-size: 35px;
  }

  h3 {
    font-size: 25px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 20px;
  }

  h6 {
    font-size: 20px;
  }
`

const CardWithImage = styled.div`
  img {
    width: calc(100% + 48px);
    margin-left: -24px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 20px;
  }
`

const ArticleParentLabel = styled.span`
  position: absolute;
  bottom: 40%;
  left: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 12px;
  color: #fff;
  z-index: 2000;
`



// WEBPACK FOOTER //
// ./src/shared/SimpleCard.tsx